module.exports = __webpack_public_path__ + "img/5-4.40561584.jpg";